import React from 'react';
import colours from 'theme/atoms/colours';

const MAX_RADIUS = 14;
const VERTICAL_PADDING = 6;

interface CursorShapeProps {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
}

export default function CursorShape({ x, y, width, height }: CursorShapeProps) {
  if (!width || !height) return null;

  const paddedY = Number(y) - VERTICAL_PADDING;
  const paddedHeight = height + VERTICAL_PADDING;
  const r = Math.min(MAX_RADIUS, width / 2, paddedHeight / 2);

  return (
    <rect
      x={x}
      y={paddedY}
      width={width}
      height={paddedHeight}
      fill={colours.neutral[100]}
      stroke={colours.neutral[200]}
      strokeWidth={1}
      rx={r}
      ry={r}
    />
  );
}
